export default "__VITE_PUBLIC_ASSET__8d0a1b65__"